import gql from "graphql-tag";

export const ListCompetitionTeams = gql`
query ListCompetitionTeams($filter: TableTeamFilterInput, $limit: Int, $nextToken: String) {
  listCompetitionTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      competitionId
      teamId
      name
      robotName
      robotNumber
      payments {
        paymentId
        voistlus
        success
      }
      technicalControl {
        status
        present
        createdAt
      }
    }
  } 
}
`;

export const GetTC = gql`
  query GetTechnicalControl($competitionId: ID!, $teamId: ID!) {
    getTechnicalControl(competitionId: $competitionId, teamId: $teamId) {
      competitionId
      teamId
      status
      present
      comments
    }
  }
`;

export const CreateTC = gql`
  mutation CreateTechnicalControl($input: CreateTechnicalControlInput!) {
    createTechnicalControl(input: $input) {
      competitionId
      teamId
      status
      present
      comments
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/TechnicalControl/graphql.js